export default function setPseudoLang(value: string | null) {
    if (typeof document === 'undefined') return null;
    const expires = `; expires=${new Date(
        Date.now() + 24 * 60 * 60 * 1000 // That's a lot of seconds.
    ).toUTCString()}`;
    document.cookie =
        '_pseudo_lang' + '=' + (value || '') + expires + '; path=/';
}
